import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef524d72"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "pro-tit"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icon"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "pro-info",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goToInfo && $options.goToInfo(...args))
  }, [_createElementVNode("img", {
    class: "img",
    src: _ctx.$imgUrlFilter($props.pro_info.url, Math.round(180 * $data.domPixelRatio()))
  }, null, 8, _hoisted_1), _createElementVNode("p", _hoisted_2, _toDisplayString($props.pro_info.name), 1), _hoisted_3]);
}